import { render, staticRenderFns } from "./WeightWash.vue?vue&type=template&id=06a4597d"
import script from "./WeightWash.vue?vue&type=script&lang=js"
export * from "./WeightWash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports